import {FC, SVGProps} from 'react';

export const StatusesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.0011 16.0001C19.3142 16.0001 22 13.3138 22 10C22 6.68631 19.3142 4 16.0011 4C12.688 4 10.0022 6.68631 10.0022 10C10.0022 13.3138 12.688 16.0001 16.0011 16.0001Z"
			fill="black"
		/>
		<path d="M22.0011 16L15.9978 22L10.0022 16H4V28.0001H28V16H22.0011Z" fill="black" />
	</svg>
);
